import { isDev } from "@/utils/enviroment-detector.ts"
import type { MidiaAppProps, MidiaProps } from "@/components/midia/midia.props.ts"
import { getLinkTarget } from "@/utils/getLinkTarget"
import './scss/midia.scss'
import { slugify } from "@/utils/slugify"

export function Midia({
    midia,
    midiaUrl,
    widthImg,
    heightImg,
    alturaMidiaVideo,
    larguraMidiaVideo,
    midiaLinkUrl,
    midiaFit,
    midiaPosition,
    midiaAltText,
    exibeMidiaComoBackground,
    alturaMidiaBackground
}: Readonly<MidiaProps>) {
    const Wrapper = midiaLinkUrl ? 'a' : 'div'
    const wrapperProps = midiaLinkUrl ? { href: midiaLinkUrl, target: getLinkTarget(midiaLinkUrl), title: midiaAltText} : {}
    const backgroundClassName = exibeMidiaComoBackground
        ? 'midia-as-background midia-fit-' + midiaFit + ' midia-position-' + slugify(midiaPosition)
        : ''
    const midiaComponentClassName = `midia-component ${backgroundClassName}`

    return (
        <Wrapper {...wrapperProps}>
            <div
                className={midiaComponentClassName}
                {...(exibeMidiaComoBackground ? {
                    style: {
                        height: `${alturaMidiaBackground}px`,
                        backgroundImage: `url(${midiaUrl})`,
                    }} : {}
                )}
            >
                {midia?.urlOriginal && (midia.urlOriginal.includes('youtube') || midia.urlOriginal.includes('vimeo')) ? (
                    <iframe
                        width={larguraMidiaVideo ?? '100%'}
                        height={alturaMidiaVideo ?? '100%'}
                        src={midiaUrl}
                        title={midiaAltText || midia?.alt || 'Midia incorporada'}
                        style={{ border: 0 }}
                        allowFullScreen
                    ></iframe>
                ) : (midia?.nomeArquivo?.includes('.mp4') || midia?.urlOriginal?.includes('.mp4')) ? (
                    <video
                        style={{
                            width: `${larguraMidiaVideo}px`,
                            height: `${alturaMidiaVideo}px`
                        }}
                        muted
                        loop
                        playsInline
                        preload='none'
                        className='lazyload'
                        data-autoplay=''
                    >
                        <source src={midiaUrl} type="video/mp4"/>
                    </video>
                ) : !exibeMidiaComoBackground ? (
                    <img
                        src={isDev() ? midiaUrl : 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='}
                        data-src={midiaUrl}
                        className='lazyload'
                        alt={midiaAltText ? midiaAltText : midia?.alt ? midia.alt : ''}
                        width={widthImg > 0 ? widthImg : 600}
                        height={heightImg > 0 ? heightImg : 600}
                        style={{ width: 'auto', height: 'auto'}}
                    />
                ) : null}
            </div>
        </Wrapper>
    )
}

export default class MidiaApp {
    constructor({
        id,
        midia,
        midiaUrl,
        widthImg,
        heightImg,
        alturaMidiaVideo,
        larguraMidiaVideo,
        midiaLinkUrl,
        midiaFit,
        midiaPosition,
        midiaAltText,
        exibeMidiaComoBackground,
        alturaMidiaBackground
    }: MidiaAppProps ) {
        const el = document.getElementById(id)
        if (!el) return
        // @ts-expect-error ReactDOM inserido no base.html
        const root = ReactDOM.createRoot(el)
        root.render(
            <Midia
                midia={midia}
                midiaUrl={midiaUrl}
                widthImg={widthImg}
                heightImg={heightImg}
                alturaMidiaVideo={alturaMidiaVideo}
                larguraMidiaVideo={larguraMidiaVideo}
                midiaLinkUrl={midiaLinkUrl}
                midiaFit={midiaFit}
                midiaPosition={midiaPosition}
                midiaAltText={midiaAltText}
                exibeMidiaComoBackground={exibeMidiaComoBackground}
                alturaMidiaBackground={alturaMidiaBackground}
            />
        )
    }
}
